// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_1h-7";
export var adjustableWidthBorderHeld = "_1h-8";
export var arrow = "_1h-3";
export var arrowButton = "_1h-4";
export var headerCell = "_1h-0";
export var help = "_1h-2";
export var icon = "_1h-1";
export var iconWrapper = "_1h-6";
export var noBorder = "_1h-b";
export var nonAdjustableWidthBorder = "_1h-9";
export var nonAdjustableWidthBorderHeld = "_1h-a";
export var textButton = "_1h-5";